import { Control, FieldValues } from "react-hook-form";
import { SxProps } from "@mui/system";

import { getOptionsForOccupancyType } from "./utils";
import { FormSelectField } from "../FormSelectField";

type Props<TValue extends FieldValues> = {
  control: Control<TValue>;
  name?: string;
  label?: React.ReactNode;
  placeholder?: string;
  tooltip?: string;
  disabled?: boolean;
  inputStyle?: SxProps;
};

const FormOccupancyTypeSelect = <TValue extends FieldValues>({
  control,
  name = "occupancyType",
  label = "Occupancy Type",
  placeholder = "Select occupancy type...",
  disabled = false,
  inputStyle = {},
  tooltip,
  ...props
}: Props<TValue>) => {
  const options = getOptionsForOccupancyType();

  return (
    <FormSelectField
      {...props}
      id="occupancy-type"
      name={name}
      control={control}
      options={options}
      label={label}
      dataTestId="occupancy-type-input"
      placeholder={placeholder}
      inputStyle={inputStyle}
      disabled={disabled}
    />
  );
};

export { FormOccupancyTypeSelect };
